import common from '../settings/common.localization.json'

function localize(strings, locale, value, tryCommon = true) {
    try {
        // Fallback language to make sure we always show something
        const fallbackLocale = 'en'

        // Try to get the information for the given locale
        let collection = strings[locale]

        // In case of chinese we only want to fallback to an empty string
        if (locale === 'zh') {
            if (!collection) {
                if (process.env.NODE_ENV === 'development') {
                    // For testing purposes we want to fallback to English...:
                    collection = strings[fallbackLocale]
                } else {
                    // No info found for chinese, return empty string
                    return ''
                }
            }
        } else if (!collection) {
            // No info found for requested language
            // fallback to English
            collection = strings[fallbackLocale]
        }

        // Try to get the information for the given locale
        let localized = collection[value]

        // In case of chinese we only want to fallback to an empty string
        if (locale === 'zh') {
            if (!localized) {
                if (process.env.NODE_ENV === 'development') {
                    // For testing purposes we want to fallback to English...:
                    localized = strings[fallbackLocale][value]
                } else {
                    // No info found for chinese, return empty string
                    return ''
                }
            }
        } else if (!localized) {
            // No info found for requested language
            // fallback to English
            localized = strings[fallbackLocale][value]
        }

        // Make sure that the localization exists in at least English
        if (localized === undefined && tryCommon) {
            return localize(common, locale, value, false)
        } else if (localized === undefined) {
            throw Error(`Localization does not exist for value '${value}'`)
        }

        // Return the localized string
        return localized
    } catch (error) {
        // The string doesn't exist as either localized or defualt language
        // create an entry in the log for this issue
        console.info(`Localization error: ${error.message}`)

        // Return empty string
        return ''
    }
}

export default localize



// WEBPACK FOOTER //
// ./src/store/localize.js